import { Loader2 } from "lucide-react";

export function LoadingCard() {
  return (
    <section
      data-testid="analyzer-data-check-loading"
      className="pa-card p-6 md:p-8 mt-6 md:mt-8 text-center"
      aria-busy="true"
      aria-live="polite"
    >
      <Loader2
        size={30}
        className="mx-auto animate-spin"
        style={{ color: "#059669" }}
      />
      <p className="mt-3 font-display text-sm uppercase tracking-wide text-slate-700">
        Verifying with cached MLB market data…
      </p>
    </section>
  );
}
